import styles from './index.module.scss';
import Modal from '@components/modal';
import Button from '@components/button';
import logo from '@assets/svg/logo.svg';
import RegularInput from '@components/regular-input';
import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { SIGN_UP_USER } from '@graphql/Mutations';
import useReduxState from '@hooks/useReduxState';
import { toastErrorMessage, toastSuccessMessage } from '@utils/utils';
import { useWallet } from '@solana/wallet-adapter-react';

export default function RegisterForm({
  open,
  close,
}: {
  open: boolean;
  close: () => void;
}): JSX.Element {
  const [username, setusername] = useState<string>('');
  const [, setUser] = useReduxState((state) => state.userData);
  const { publicKey } = useWallet();
  const [registerUser] = useMutation(SIGN_UP_USER, {
    onCompleted: (data) => {
      setUser({
        type: 'SET_USER_DATA',
        arg: data.signupUser,
      });
      toastSuccessMessage('Succesfully Registered');
      close();
    },
    onError: (error) => {
      handleTextChange('');
      toastErrorMessage(error.message);
    },
  });

  const handleTextChange = useCallback(
    (text: string) => {
      setusername(text);
    },
    [username]
  );

  const handleRegistration = async () => {
    if (username !== '') {
      await registerUser({
        variables: {
          wallet_address: publicKey?.toString(),
          username,
        },
      });
    } else {
      toastErrorMessage('Please put a valid username');
    }
  };

  return (
    <Modal {...{ isOpen: open, close }}>
      <div className={styles.register}>
        <img src={logo} alt="logo" />
        <h1>Register and start playing!</h1>
        <h3>Start the duel!</h3>
        <RegularInput
          name="register input"
          placeholder="Your username here"
          value={username}
          onChange={(e) => handleTextChange(e.currentTarget.value)}
        />
        <Button color="green" onClick={handleRegistration}>
          Register
        </Button>
      </div>
    </Modal>
  );
}
